import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-option',
  imports: [],
  templateUrl: './checkin-option.component.html',
  styleUrl: './checkin-option.component.css'
})
export class CheckintOptionComponent {

}
